document.addEventListener("DOMContentLoaded", initSansuTestimonials);
document.addEventListener("shopify:section:load", initSansuTestimonials);

function initSansuTestimonials(){

document.querySelectorAll(".sansu-testimonial-swiper").forEach((slider)=>{

if(slider.swiper){
slider.swiper.destroy(true,true);
}

new Swiper(slider,{

slidesPerView:Number(slider.dataset.mobile),

spaceBetween:20,

loop:slider.dataset.loop==="true",

observer:true,
observeParents:true,

autoplay:slider.dataset.autoplay==="true"
?{
delay:3500,
disableOnInteraction:false,
pauseOnMouseEnter:true
}
:false,

navigation:{
nextEl:slider.querySelector(".swiper-button-next"),
prevEl:slider.querySelector(".swiper-button-prev")
},

breakpoints:{

750:{
slidesPerView:Number(slider.dataset.tablet)
},

990:{
slidesPerView:Number(slider.dataset.desktop)
}

}

});

});

}